export default {
  setUserTaskListing: function (userUuid, taskListingState) {
    window.localStorage.setItem(userUuid, JSON.stringify(taskListingState))
  },
  getUserTaskListing: function (userUuid) {
    return window.localStorage.getItem(userUuid) || JSON.stringify({})
  }
}
